module.exports = __webpack_public_path__ + "assets/img/icon_2.6cdc0858.png";